/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { StatusPage } from "@/shared/ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';

type NotFoundPageProps = { redirect?: string };
const NotFoundPage: React.FC<NotFoundPageProps> = ({ redirect = "/" }) => {
  const { t } = useTranslation("@pages/not-found");
  const navigate = useNavigate();

  return (
    <StatusPage
      testId="not-found-page"
      title={t("title")}
      description={t("body")}
      actionLabel={t("goHome")}
      onAction={() => navigate(redirect)}
    />
  );
};

export default NotFoundPage;
